import { useState, useEffect, useRef } from "react";

import { API_URL, scroll, getValFromLS } from "../../helpers";

import Hdg from "../../components/Hdg";
import Notice from "../../components/Notice";
import Alert from "../../components/Alert";
import Input from "../../components/Input";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

import Nav from "../Nav";

import Table1 from "./Table1";
import Table2 from "./Table2";
import Table3 from "./Table3";
import Table4 from "./Table4";
import Form from "./Form";

function sortValues(golf, sporting, gift, array) {
	let newArray = [];
	array.forEach((item) => {
		if (item.key === "Guest ID") {
			newArray.push({
				key: item.key,
				value: item.value,
			});
		} else if (item.key === "Invited By") {
			newArray.push({
				key: item.key,
				value: item.value,
			});
		} else if (golf === 1 && item.key === "Golf Assignment") {
			newArray.push({
				key: item.key,
				value: item.value,
			});
		} else if (sporting === 1 && item.key === "Sporting Clays") {
			newArray.push({
				key: item.key,
				value: item.value,
			});
		} else if (gift === 1 && item.key === "Picked Up Gift Package") {
			newArray.push({
				key: item.key,
				value: item.value,
			});
		} else if (item.key === "Gift") {
			newArray.push({
				key: item.key,
				value: item.value,
			});
		} else if (item.key === "Notes") {
			newArray.push({
				key: item.key,
				value: item.value,
			});
		} else if (item.key === "Last Updated") {
			newArray.push({
				key: item.key,
				value: item.value,
			});
		}
	});
	return newArray;
}

const Guest = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [results, setResults] = useState([]);
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [notice, setNotice] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const formElement = useRef(null);

	useEffect(() => {
		const init = async () => {
			const token = getValFromLS("vtoUserToken")
				? getValFromLS("vtoUserToken")
				: "";
			const url = new URL(`${API_URL}/admin/guestInit`);
			const params = {
				token,
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...json.user });
					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e = null, id = 0) => {
		if (e) {
			e.preventDefault();
		} else {
			formElement.current.guestStr.value = id;
			handleUpdate("guestStr", id);
			setResults([]);
		}
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});
		setDetails({});

		const url = new URL(`${API_URL}/admin/guest`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "guestStr" && id) {
				data.append(key, id);
			} else {
				data.append(key, value);
			}
		});
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({
					type: "success",
					text: json.text,
				});

				setDetails({ ...json });
			} else if (json && json.resp === 2) {
				if (json.results.length === 1) {
					handleMatch(json.results[0].id);
				} else {
					setResults(json.results);
					setMsg({
						type: "notice",
						text: json.text,
					});
				}
			} else {
				setResults([]);
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleMatch = async (id) => {
		handleSubmit(null, id);
	};

	const handleClick = () => {
		formElement.current.guestStr.value = "";
		setNames({});
		setDetails({});
		setMsg({});
	};

	const handleSuccess = (text, guestId) => {
		scroll();
		setNotice({ type: "success", text });
		handleSubmit(null, guestId);
	};

	/*
    const handleRemove = async (e, id, event) => {
      e.preventDefault();

    
      const url = new URL(`${API_URL}/dashboardGuestRemove`);
      let data = new FormData();
      data.append("q", id);
      data.append("event", event);
      data.append("auth", getValFromLS("dash", true));

      try {
        const response = await fetch(url, {
          method: "POST",
          body: data,
        });
        const json = await response.json();
        if (json && json.resp === 1) {
          setDetails({ ...json });
        } else {
        }
      } catch (error) {}
    };
  */

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Guest Information" admin={true} />

						<p>
							Use this form to locate BFC guests, view their information and
							toggle Gift Package pickup status.
						</p>

						{notice.type && <Notice data={notice} />}

						<div className="spacer"></div>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<div className="form-group">
								<Input
									name="guestStr"
									label="Guest’s ID, Last Name or Last, First"
									reqd={true}
									value={names.guestStr || ""}
									update={handleUpdate}
									errors={errors}
									note="Note: Use partial last name or format as last, first for exact matches"
								/>

								<div className="empty" />
							</div>

							<div className="msg-submit" style={{ marginTop: "30px" }}>
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" ||
										msg.type === "notice" ||
										msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit submit="Locate Guest" />
								</div>
							</div>

							<div className="results-container">
								{results.map((item) => {
									return (
										<button
											type="button"
											className="naked"
											key={item.id}
											onClick={(e) => handleMatch(item.id)}
										>
											{`${item.id} ${item.name}`}
										</button>
									);
								})}
							</div>
						</form>

						{details.id && (
							<>
								<div className="reset-container">
									<button type="button" className="naked" onClick={handleClick}>
										<i className="fa fa-times-circle-o fa-lg working" />
									</button>
								</div>

								<Table1 details={details} />
								<Table2 invite={details.invite} />
								<Table3 details={details} />
								<Table4
									values={sortValues(
										details.invite.golf.status,
										details.invite.sporting.status,
										details.invite.gift.status,
										details.invite.valuesAdmin
									)}
								/>
								<Form
									giftDisabled={details.invite.gift.status === 1 ? false : true}
									values={{
										guestId: details.values[0].value,
										pickedup: details.invite.valuesAdmin[3].value,
										gift: details.invite.valuesAdmin[4].value,
										notes: details.invite.valuesAdmin[5].value,
										updated: details.invite.valuesAdmin[6].value,
									}}
									success={handleSuccess}
								/>
							</>
						)}

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={5} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Guest;
